import React from 'react';
import { makeStyles } from '@mui/styles';
import { Radio, useTheme } from '@mui/material';
import { appInsights } from '../../../auth/appInsight';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const useStyles = makeStyles((theme) => ({
  // root: {
  //     padding: "10px",
  // }
}));

export const FreedomRadioButton1 = (props) => {
  const { checked, height, width, radioiconsize, margin } = props;
  const classes = useStyles();
  const theme = useTheme();
  // debugger
  try {
    return (
      <Radio
        {...props}
        // size="small"
        sx={{
          background: 'transparent',
          margin: margin || '0px',
          height: `${height}px`,
          width: `${width}px`,
          borderRadius: '7px',
          border: `2px solid ${theme.palette.border.border}`,
          color: theme.palette.border.border,
          '& .MuiSvgIcon-root': {
            fontSize: radioiconsize || 18,
            [theme.breakpoints.up('xll')]: {
              fontSize: getStringProduct(1.25, radioiconsize || 18),
            },
            [theme.breakpoints.up('xlll')]: {
              fontSize: getStringProduct(1.66, radioiconsize || 18),
            },
            [theme.breakpoints.up('xl4')]: {
              fontSize: getStringProduct(2.46, radioiconsize || 18),
            },

          },
          cursor: 'pointer',
          // "&:hover": {
          //   background: theme.palette.primary.white,
          // },
          // "&.Mui-checked:hover": {
          //   background: theme.palette.primary.white,
          // },
          '&.Mui-checked': {
            color: theme.palette.border.border,
            background: theme.palette.background.default
          },
          [theme.breakpoints.up('xll')]: {
              margin: getStringProduct(1.25, margin || '0px'),
              height: getStringProduct(1.25, `${height}px`),
              width: getStringProduct(1.25, `${width}px`),
              borderRadius: getStringProduct(1.25, '7px'),
              border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.border}`)
            },
            [theme.breakpoints.up('xlll')]: {
              margin: getStringProduct(1.66, margin || '0px'),
              height: getStringProduct(1.66, `${height}px`),
              width: getStringProduct(1.66, `${width}px`),
              borderRadius: getStringProduct(1.66, '7px'),
              border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.border}`)
            },
            [theme.breakpoints.up('xl4')]: {
              margin: getStringProduct(2.46, margin || '0px'),
              height: getStringProduct(2.46, `${height}px`),
              width: getStringProduct(2.46, `${width}px`),
              borderRadius: getStringProduct(2.46, '7px'),
              border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.border}`)
            },
        }}
        // sx={{
        //   "&, &.Mui-checked": {
        //     color: radiocolor,
        //   },
        // }}
      />
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};
